import React from 'react'

const Head = () => {
    return (
        <div className='head'>

            <div className='head2'>
                <p><i class="fa fa-map-marker"></i> 2/6B Priyadarshini Colony Sitapur Road Aliganj Lucknow  </p>
            </div>


            <div className='head2'>
                <p> <i class="fa fa-phone"></i> 0522-3585006    9455020306 9119992821</p>
            </div>


            <div className='head2'>
                <p> <i class="fa fa-envelope"></i> drankushmisra@gmail.com</p>
            </div>


        </div>
    )
}

export default Head